if (!customElements.get('one-wardrobe-carousel')) {
  customElements.define('one-wardrobe-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track = this.querySelector('.one-wardrobe, .one-selection-grid, [data-wardrobe-track]');
      this.cards = [...this.querySelectorAll('.one-world-card, .one-selection-grid > li, [data-wardrobe-card]')];
      if (!this.track || !this.cards.length) return;
      this.previous = this.querySelector('[data-wardrobe-previous]');
      this.next = this.querySelector('[data-wardrobe-next]');
      this.previous.addEventListener('click', () => this.go(this.index - 1), options);
      this.next.addEventListener('click', () => this.go(this.index + 1), options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.sync());
      }, { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        const target = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.cards.length - 1 }[event.key];
        if (target === undefined) return;
        event.preventDefault();
        this.go(target);
      }, options);
      this.resize = new ResizeObserver(() => this.sync());
      this.resize.observe(this.track);
      this.querySelector('.one-wardrobe-controls').hidden = false;
      this.sync();
    }
    positions() {
      const start = this.cards[0].getBoundingClientRect().left;
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      return this.cards.map(card => Math.min(maximum, card.getBoundingClientRect().left - start));
    }
    go(index) {
      const target = Math.max(0, Math.min(index, this.cards.length - 1));
      this.track.scrollTo({ left: this.positions()[target], behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    sync() {
      const positions = this.positions();
      this.index = positions.reduce((best, value, index) => Math.abs(value - this.track.scrollLeft) < Math.abs(positions[best] - this.track.scrollLeft) ? index : best, 0);
      this.previous.disabled = this.index === 0;
      this.next.disabled = this.index === this.cards.length - 1;
      this.querySelector('[data-wardrobe-status]').textContent = `${this.index + 1} / ${this.cards.length}`;
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
